import en from './messages/en.json';
import es from './messages/es.json';
import fr from './messages/fr.json';
import de from './messages/de.json';
import tr from './messages/tr.json';
import ptBR from './messages/pt-BR.json';
import vi from './messages/vi.json';
import type { WidgetLocale } from './resolve-locale';

export type MessageKey = keyof typeof en;

export type MessageParams = Record<string, string | number>;

const catalogs: Record<WidgetLocale, Record<string, string>> = {
  en,
  es,
  fr,
  de,
  tr,
  'pt-BR': ptBR,
  vi,
};

const PLACEHOLDER_RE = /\{([a-zA-Z]+)\}/g;

function interpolate(template: string, params?: MessageParams): string {
  if (!params) return template;
  return template.replace(PLACEHOLDER_RE, (match, name: string) => {
    if (Object.prototype.hasOwnProperty.call(params, name)) {
      return String(params[name]);
    }
    return match;
  });
}

function lookup(locale: WidgetLocale, key: MessageKey): string {
  const localized = catalogs[locale][key];
  if (typeof localized === 'string' && localized.length > 0) {
    return localized;
  }
  const english = catalogs.en[key];
  if (typeof english === 'string' && english.length > 0) {
    return english;
  }
  // Never return the raw key or an empty string.
  return ' ';
}

/** Look up a message for `locale`, falling back to English, then interpolate. */
export function translate(
  locale: WidgetLocale,
  key: MessageKey,
  params?: MessageParams
): string {
  return interpolate(lookup(locale, key), params);
}

/**
 * Value for an element `lang` attribute. Always returns the locale (including
 * `en`) so screen readers get the correct language when the host page differs.
 */
export function langAttr(locale: WidgetLocale): string {
  return locale;
}
